import styled from "styled-components";
import { LiveCasinoGridItemBetBehindButtonDefaultBox } from "./live-casino-grid-item-bet-behind-button.default.box";

export const LiveCasinoGridItemBetBehindButtonCasino777Box = styled(LiveCasinoGridItemBetBehindButtonDefaultBox)`
    color: ${props => props.theme.colors.danger};
    background: ${props => props.theme.colors.background};

    &:hover {
        color: ${props => props.theme.colors.background};
        background: ${props => props.theme.colors.backgroundActive};
    }

    ${({theme}) => theme.mediaQuery.sAndBelow} {
        &:hover {
            color: ${props => props.theme.colors.backgroundActive};
        }
    }
`;